import { render, staticRenderFns } from "./UpdatePageForm.vue?vue&type=template&id=e3039976&scoped=true&"
import script from "./UpdatePageForm.vue?vue&type=script&lang=ts&"
export * from "./UpdatePageForm.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePageForm.vue?vue&type=style&index=0&id=e3039976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3039976",
  null
  
)

export default component.exports